import { Pipe, PipeTransform } from '@angular/core';
import { InherentRiskPluginService } from './inherent-risk.service';

@Pipe({
  name: 'inherentriskimpact',
  standalone: false
})
export class InherentRiskImpactPipe implements PipeTransform {
  public impactOptions: any[];
  constructor(private service: InherentRiskPluginService) {
    this.impactOptions = this.service.getImpactOptions();
  }

  transform(id: any): any {
    if (!id) return '&nbsp;';
    return this.service.getValue(parseInt(id), this.impactOptions);
  }
}
